import { KeyboardKeys } from '@shared/models/keyboard.model';

/**
 * Whether ArrowRight should copy the gray default into an empty field.
 *
 * Tab is not a fill key, so it keeps moving focus. A field that already has
 * text is left alone so ArrowRight still steps the caret. Shift+ArrowRight
 * stays a selection gesture even when the field is empty.
 */
export const shouldFillEmptyFieldOnArrowRight = (
  event: { key: string; shiftKey: boolean },
  value: string,
): boolean => {
  if (event.key !== KeyboardKeys.ARROW_RIGHT) return false;
  if (event.shiftKey) return false;
  if (value !== '') return false;
  return true;
};
